import JassEventId from './eventid';

/**
 * type dialogevent
 */
export default class JassDialogEvent extends JassEventId {}
